import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PaginationActionsService } from './pagination-actions.service';

export interface PaginationSettigs {
  endRow: number
  firstPage: number
  hasNextPage: boolean
  hasPreviousPage: boolean
  isFirstPage: boolean
  isLastPage: boolean
  lastPage: number
  list: any[]
  navigateFirstPage: number
  navigateLastPage: number
  navigatePages: number
  navigatepageNums: number[]
  nextPage: number
  pageNum: number
  pageSize: number
  pages: number
  prePage: number
  size: number
  startRow: number
  total: number
}

@Component({
  selector: 'app-pagination-actions',
  templateUrl: './pagination-actions.component.html',
  styleUrls: ['./pagination-actions.component.scss']
})
export class PaginationActionsComponent implements OnInit {

  @Input() data: PaginationSettigs;
  @Input() showResultLimit: boolean = true
  @Output() onNextPage = new EventEmitter()
  @Output() onPreviusPage = new EventEmitter()
  @Output() nuevo = new EventEmitter()

  @Input() sizeList: number[] = [25, 50, 100];
  @Input() visivility = true

  showPageSize: boolean = false

  private _sizeChanges$ = new Subject<number>()

  constructor(
    private service: PaginationActionsService,
  ) { }

  ngOnInit(): void {
      if (!localStorage.getItem('pageSize')) {
          localStorage.setItem('pageSize', '25')
      }

  }

  updateSize(size) {
    this.data.pageSize = size
    this.service.setSize(this.data.pageSize)
    this.showPageSize = false
    localStorage.setItem('pageSize', size)
    this._sizeChanges$.next(size)
    this.nuevo?.emit(size)

  }

  get sizeChanges(): Observable<number> {
    return this._sizeChanges$.asObservable()
  }

  prevPage() {
    this.onPreviusPage?.emit(null)
  }

  nextPage() {
    this.onNextPage?.emit(null)
  }

}
